import { render, staticRenderFns } from "./modal-order-view-issue.vue?vue&type=template&id=656263d5&scoped=true"
import script from "./modal-order-view-issue.vue?vue&type=script&lang=js"
export * from "./modal-order-view-issue.vue?vue&type=script&lang=js"
import style0 from "./modal-order-view-issue.vue?vue&type=style&index=0&id=656263d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656263d5",
  null
  
)

export default component.exports